import { config } from "./client";

/**
 * @deprecated Use Config.ENGAGE_MFE_BASE_DOMAIN instead.
 */

export const ENGAGE_MFE_BASE_DOMAIN = config.ENGAGE_MFE_BASE_DOMAIN;
/**
 * @deprecated Use Config.DATADOG_APPLICATION_ID instead.
 */

export const DATADOG_APPLICATION_ID = config.DATADOG_APPLICATION_ID;
/**
 * @deprecated Use Config.DATADOG_CLIENT_TOKEN instead.
 */

export const DATADOG_CLIENT_TOKEN = config.DATADOG_CLIENT_TOKEN;
/**
 * @deprecated Use Config.AUTH_CONFIG instead.
 */

export const AUTH_CONFIG = config.AUTH_CONFIG;
/**
 * @deprecated Use Config.API_BASE_URL instead.
 */

export const API_BASE_URL = config.API_BASE_URL;
/**
 * @deprecated Use Config.CONFIGCAT_SDK_KEY instead.
 */

export const CONFIGCAT_SDK_KEY = config.CONFIGCAT_SDK_KEY;
/**
 * @deprecated Use Config.SOCKET_HOST instead.
 */

export const SOCKET_HOST = config.SOCKET_HOST;
/**
 * @deprecated Use Config.CAMPAIGNS_HIVE_PROXY instead.
 */

export const CAMPAIGNS_HIVE_PROXY = config.CAMPAIGNS_HIVE_PROXY;
/**
 * @deprecated Use Config.MFE_CAT_URL instead.
 */

export const MFE_CAT_URL = config.MFE_CAT_URL;
/**
 * @deprecated Use Config.API_STRATEGY instead.
 */

export const API_STRATEGY = config.API_STRATEGY;
